module.exports = __webpack_public_path__ + "static/media/veirfyInProgress-desktop.bf5cf83a.png";